import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/scss/vuetify/overrides.scss";

//Custom Icons Imports
import Certificate from "@/components/svgComponents/Certificate.vue";
import Class from "@/components/svgComponents/Class.vue";
import Teams from "@/components/svgComponents/Teams.vue";
import Paper from "@/components/svgComponents/Paper.vue";
import Student from "@/components/svgComponents/Student.vue";
import StudentThin from "@/components/svgComponents/StudentThin.vue";
import Teacher from "@/components/svgComponents/Teacher.vue";
import IconLogo from "@/components/svgComponents/IconLogo.vue";
import IconTextLogo from "@/components/svgComponents/IconTextLogo.vue";
import Quiz from "@/components/svgComponents/Quiz.vue";

Vue.use(Vuetify);

// const theme = {
//   yee: "#00a8a9",
//   primary: "#398bf7", // change header color from here || "#1e88e6", "#21c1d6", "#fc4b6c", "#563dea", "#9C27b0", "#ff9800"
//   info: "#1e88e5",
//   success: "#06d79c",
//   accent: "#ef5350",
//   default: "#563dea",
//   details: "#607D8B",
// };

const theme_dark = {
  background_grey: "#f0f0f0",

  text_color: "#fff",

  background: "#1d2228",
  primary: "#00B5AE", // change header color from here || "#1e88e6", "#21c1d6", "#fc4b6c", "#563dea", "#9C27b0", "#ff9800"

  side_bar_icon: "#FFFFFF",
  side_bar_text: "#FFFFFF",

  side_bar_active_icon: "#FFFFFF",
  side_bar_active_text: "#FFFFFF",

  info: "#1e88e5",
  success: "#06d79c",
  accent: "#ef5350",
  default: "#563dea",
  secondary: "#0596a9",
  yee: "#00a8a9",

  accent_darken: "#8b3a3a",
  accent_lighten: "#f4a460",

  blue_grey: "#607D8B",
  blue_grey_lighten: "#ECEFF1",

  primary_darken: "#00938d",
  primary_light: "#DCF1F0",

  primary_white: "#fff",
  primary_text_color: "#d3dbe6",
  indigo: "#a1aab5",
  indigo_dark: "#444444",

  accent_darken_upload: "#ffc7c7",

  firstColor: "#45D0DA",
  secondColor: "#f9b32f",
  thirdColor: "#607D8B",
};

const theme_white = {
  background_grey: "#f0f0f0",
  indigo_dark: "#444444",

  text_color: "#000",

  background: "#F9F9F9",
  primary: "#00B5AE", // change header color from here || "#1e88e6", "#21c1d6", "#fc4b6c", "#563dea", "#9C27b0", "#ff9800"
  primary_light: "#DCF1F0",

  side_bar_icon: "#383838",
  side_bar_text: "#1d2228",

  side_bar_active_icon: "#00A8A9",
  side_bar_active_text: "#00BAB3",

  info: "#1e88e5",
  success: "#06d79c",
  accent: "#ef5350",
  default: "#563dea",
  secondary: "#0596a9",
  yee: "#00a8a9",

  error: "#e3342f",

  accent_darken: "#DD2C00",
  accent_darken_upload: "#ffc7c7",

  accent_lighten: "#f9b32f",

  blue_grey: "#607D8B",
  blue_grey_lighten: "#ECEFF1",

  primary_darken: "#00938d",

  primary_white: "#fff",

  primary_text_color: "#666666",
  firstColor: "#45D0DA",
  secondColor: "#f9b32f",
  thirdColor: "#607D8B",
};

export default new Vuetify({
  icons: {
    values: {
      country: "mdi-earth",
      state: "mdi-office-building",
      city: "mdi-domain",
      timeZone: "mdi-map-clock",
      email: "mdi-email",
      eye: "mdi-eye",
      eyeOff: "mdi-eye-off",
      password: "mdi-lock",
      accountDetails: "mdi-account-details",
      dateOfBirth: "mdi-cake",
      phone: "mdi-cellphone",
      job: "mdi-account-hard-hat",
      list: "mdi-format-list-text",
      textPlus: "mdi-text-box-plus",
      startDate: "mdi-calendar-start",
      endDate: "mdi-calendar-end",
      header: "mdi-page-layout-header",
      status: "mdi-list-status",
      link: "mdi-link",
      classroom: "mdi-google-classroom",
      score: "mdi-counter",
      event: "mdi-calendar-clock",
      notice: "mdi-bullhorn",
      timeLine: "mdi-timeline-clock",
      quota: "mdi-human-queue",
      lecturer: "mdi-human-male-board-poll",
      day: "mdi-calendar-today",
      gender: "mdi-gender-male-female",
      address: "mdi-map-marker",
      circle: "mdi-circle",
      circleOutlined: "mdi-circle-outline",
      calendar: "mdi-calendar",

      close: "mdi-close-circle",
      check: "mdi-check-circle",
      save: "mdi-content-save",
      earth: "mdi-earth",

      add: "mdi-plus-circle-outline",
      account: "mdi-account",
      databaseCog: "mdi-database-cog",
      filter: "mdi-filter",
      accountSub: "mdi-account-minus",
      copy: "mdi-content-copy",
      checkDecagram: "mdi-check-decagram",

      testing: "mdi-ab-testing",

      edit: "mdi-pencil",
      delete: "mdi-delete",

      download: "mdi-download-circle",
      upload: "mdi-tray-arrow-up",
      send: "mdi-send",

      menuDown: "mdi-menu-down",
      message: "mdi-message",

      education: "mdi-account-school",

      sendEmail: "mdi-email-fast",
      alertCircle: "mdi-alert-circle",

      //Social Media
      facebook: "mdi-facebook",
      instagram: "mdi-instagram",
      twitter: "mdi-twitter",

      levelUp: "mdi-upload-multiple",
      question: "mdi-help-circle",

      center: "mdi-domain-plus",
      complete: "mdi-clipboard-check-multiple",

      certificates: "mdi-certificate",
      participation: "mdi-file-certificate",

      examLocation: "mdi-book-marker",
      printer: "mdi-printer",

      excel: "mdi-file-excel",

      sync: "mdi-sync",
      star: "mdi-star",
      play: "mdi-play-circle-outline",

      minus: "mdi-minus-circle-outline",

      //arrows
      rightArrow: "mdi-arrow-right-thick",
      leftArrow: "mdi-arrow-left-thick",

      viewList: "mdi-view-list",

      order: "mdi-package-variant",

      certificate: {
        component: Certificate,
      },
      class: {
        component: Class,
      },
      teams: {
        component: Teams,
      },
      paper: {
        component: Paper,
      },
      student: {
        component: Student,
      },
      studentThin: {
        component: StudentThin,
      },
      teacher: {
        component: Teacher,
      },
      iconLogo: {
        component: IconLogo,
      },
      iconTextLogo: {
        component: IconTextLogo,
      },

      quiz: {
        component: Quiz,
      },
    },
  },
  theme: {
    themes: {
      dark: theme_dark,
      light: theme_white,
    },
    dark: false, // If you want to set dark theme then dark:true else set to false
  },
  rtl: false, // If you want to set rtl theme then rtl:true else set to false
});
